import { useState } from "react";
import { Download, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { printPdfBlob } from "@/lib/printPdf";
import { Button } from "@/components/ui/button";
import { saveBlob } from "@/components/resources/resourceApi";
import { errMsg } from "./ResolveDialog";

/** Print / download a server-built PDF (diary summary or week-to-week comparison). */
export function DiaryPdfButtons({ url, params, filename, label = "Print summary", testPrefix = "diary-pdf" }) {
  const [busy, setBusy] = useState(null);
  async function run(kind) {
    setBusy(kind);
    try {
      const { data } = await api.get(url, { params, responseType: "blob" });
      const blob = new Blob([data], { type: "application/pdf" });
      if (kind === "print") await printPdfBlob(blob);
      else saveBlob(blob, filename);
    } catch (e) {
      toast.error("Couldn't create the PDF", { description: errMsg(e) });
    } finally {
      setBusy(null);
    }
  }
  return (
    <div className="flex gap-2" data-testid={`${testPrefix}-actions`}>
      <Button size="sm" variant="outline" onClick={() => run("print")} disabled={!!busy} data-testid={`${testPrefix}-print`}>
        {busy === "print" ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Printer className="mr-1.5 h-3.5 w-3.5" />}{label}
      </Button>
      <Button size="sm" variant="ghost" onClick={() => run("download")} disabled={!!busy} data-testid={`${testPrefix}-download`}>
        {busy === "download" ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Download className="mr-1.5 h-3.5 w-3.5" />}PDF
      </Button>
    </div>
  );
}

const slug = (s) => (s || "client").replace(/[^A-Za-z0-9]+/g, "-");

export const DiarySummaryPdf = ({ sub }) => (
  <DiaryPdfButtons url={`/checkin-submissions/${sub.id}/diary-pdf`} filename={`diary-summary-${slug(sub.client_name)}-${sub.period?.start || ""}.pdf`} />
);
